import styled, { keyframes } from "styled-components";
import { mobile } from "../utilities/responsive";

const MAILHIDE_URL = "https://mailhide.io/e/kWBSwZsz";

const holoShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;


const Container = styled.footer`
  margin-left: 60px;
  background: #000;
  color: #eeeeea;
  font-family: Poppins, sans-serif;
  padding: 48px 56px 0;

  ${mobile({
    marginLeft: "clamp(30px, calc(5vw + 10px), calc(5vw + 10px))",
  })}

  @media only screen and (max-width: 760px) {
    padding: 34px 24px 0;
  }
`;

const Dots = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 18px;
`;

// const Dot = styled.span`
//   width: 5px;
//   height: 5px;
//   border-radius: 50%;
//   background: #eeeeea;
// `;

const BigDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 4px;
  background: #eeeeea;
`;

const Wordmark = styled.h2`
  font-family: "Big Shoulders Inline Display", sans-serif;
  font-weight: 600;
  font-size: clamp(4.5rem, 11vw, 10.5rem);
  line-height: 0.88;
  text-transform: uppercase;
  margin: 0 0 40px;
`;

const Cols = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.4fr 1.2fr 1fr;
  gap: 32px;
  padding-bottom: 48px;

  @media only screen and (max-width: 760px) {
    grid-template-columns: 1fr 1fr;
    gap: 22px;
  }
`;

const Col = styled.div``;

const ColTitle = styled.h5`
  margin: 0 0 14px;
  font-size: 0.7rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #888;
  font-weight: 500;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  margin: 8px 0;
`;

const CtaItem = styled.li`
  margin: 14px 0 0;
`;

const ALink = styled.a`
  color: #eeeeea;
  text-decoration: none;
  font-size: 0.95rem;
  position: relative;
  padding-bottom: 3px;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 2px;
    background: #eeeeea;
    transform: translateX(-50%);
    transition: width 0.45s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const Cta = styled.a`
  display: inline-block;
  border: 2px solid #eeeeea;
  border-radius: 2rem;
  padding: 8px 22px;
  text-decoration: none;
  font-size: 0.85rem;
  color: #eeeeea;
  transition: color 0.3s ease, border-color 0.3s ease;

  &:hover {
    background: linear-gradient(
      115deg,
      #00c6ff 0%,
      #2f7bff 25%,
      #9d50bb 50%,
      #ff6ec4 75%,
      #00c6ff 100%
    );
    background-size: 300% 300%;
    animation: ${holoShift} 3s ease-in-out infinite;
    border-color: rgba(255, 255, 255, 0.65);
    color: #fff;
  }

  @media (prefers-reduced-motion: reduce) {
    &:hover {
      animation: none;
    }
  }
`;

const Baseline = styled.div`
  border-top: 0.5px solid #444;
  margin: 0 -56px;
  padding: 18px 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.78rem;
  color: #999;
  flex-wrap: wrap;
  gap: 8px;

  @media only screen and (max-width: 760px) {
    margin: 0 -24px;
    padding: 16px 24px;
  }
`;

const Footer = () => {
  const openMailhide = (e) => {
    const popup = window.open(
      MAILHIDE_URL,
      "mailhidepopup",
      "width=580,height=635"
    );
    if (popup) e.preventDefault();
  };


  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container>
      <Dots>
        <BigDot /> 
        <BigDot /> 
        <BigDot /> 
      </Dots>
      <Wordmark>Ash Coca</Wordmark>
      <Cols>
        <Col>
          <ColTitle>Say Hello</ColTitle>
          <List>
            <Item>
              <ALink
                href={MAILHIDE_URL}
                target="_blank"
                rel="noreferrer"
                onClick={openMailhide}
              >
                a......@gmail.com
              </ALink>
            </Item>
            <CtaItem>
              <Cta
                href={MAILHIDE_URL}
                target="_blank"
                rel="noreferrer"
                onClick={openMailhide}
              >
                Let's Connect
              </Cta>
            </CtaItem>
          </List>
        </Col>
        <Col>
          <ColTitle>Menu</ColTitle>
          <List>
            <Item>
              <ALink href="#home">Home</ALink>
            </Item>
            <Item>
              <ALink href="#projects">Experience</ALink>
            </Item>
            <Item>
              <ALink href="#reviews">Feedback</ALink>
            </Item>
            <Item>
              <ALink href="/resume.pdf" target="_blank">
                Resume
              </ALink>
            </Item>
          </List>
        </Col>
        <Col>
          <ColTitle>Follow</ColTitle>
          <List>
            <Item>
              <ALink
                href="https://github.com/Ashcoca"
                target="_blank"
                rel="noreferrer"
              >
                GitHub
              </ALink>
            </Item>
            <Item>
              <ALink
                href="https://www.linkedin.com/in/ashvin-coca"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </ALink>
            </Item>
          </List>
        </Col>
        <Col>
          <ColTitle>Elsewhere</ColTitle>
          <List>
            <Item>
              <ALink href="#home" onClick={scrollToTop}>
                Back to top ↑
              </ALink>
            </Item>
          </List>
        </Col>
      </Cols>
      <Baseline>
        <span>© 2026 Ash Coca. All rights reserved.</span>
        <span>Painstakingly designed and built by the brain and hands of Ash Coca.</span>
      </Baseline>
    </Container>
  );
};

export default Footer;
